import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { createTheme } from '@mui/material/styles';

const styles = theme => ({
  root: {
    width: '100%',
    margin: 'auto',
    backgroundColor: theme.palette.background.paper,
  },
  textroot: {
    width: '100%',
    margin: 'auto',
  },
});

class ListInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      answer: '',
    };
  }

  render() {
    const { classes, data } = this.props;
    const rawPrefillValue = data?.autoAnswer || data?.answer_data_default || '';
    const prefillValue = typeof rawPrefillValue === 'object' ? '' : rawPrefillValue;
    // Convert array to newline-separated string if needed
    const displayValue = Array.isArray(prefillValue)
      ? prefillValue.join('\n')
      : prefillValue || 'Press enter to insert next value';

    const theme = createTheme({
      palette: {
        primary: { 500: '#000000' },
      },
      typography: { useNextVariants: true },
    });
    try {
      return (
        <div className={classes.root}>
          <TextField
            multiline
            rows="3"
            className={classes.textroot}
            variant="outlined"
            value={displayValue}
            InputProps={{
              readOnly: true,
              className: 's-text',
            }}
          />
        </div>
      );
    } catch (e) {
      return <h5>Error encountered</h5>;
    }
  }
}

ListInput.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ListInput);
